<template>
    <div>
        <transition name="page">
            <v-container class="pa-5" fluid>
                <CostCenterNumberDialog
                    :is-open="costCenterNumberDialog"
                    :cost-center-number-data="costCenterNumber"
                    @on-save="getCostCenterNumbers()"
                    @on-close="closeCostCenterNumberDialog"
                />
                <page-title>Baza MPK</page-title>
                <v-row align="center" justify="space-between">
                    <v-col cols="12" lg="4">
                        <v-btn
                            class="mr-2"
                            color="secondary"
                            medium
                            data-sentry-label="Dodaj MPK"
                            @click="showCostCenterNumberDialog"
                        >
                            <v-icon left>
                                mdi-plus
                            </v-icon>
                            Dodaj MPK
                        </v-btn>
                        <v-btn
                            color="secondary"
                            medium
                            outlined
                            data-sentry-label="Synchronizuj MPK z XL"
                            :disabled="!hasFinancesCreatePermission"
                            :loading="syncLoading"
                            @click="syncCostCenterNumbers"
                        >
                            <v-icon left>
                                mdi-refresh
                            </v-icon>
                            Synchronizuj MPK z XL
                        </v-btn>
                    </v-col>
                    <v-col cols="12" lg="2" class="text-right">
                        <v-text-field
                            v-model="filters.search"
                            append-icon="mdi-magnify"
                            label="Szukaj..."
                            single-line
                            clearable
                            hide-details
                            solo
                            dense
                            @keyup.enter="changeFilter"
                            @click:append="changeFilter"
                            @click:clear="clearFilter('search')"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-data-table
                                :headers="headers"
                                :items="costCenterNumbers"
                                :loading="costCenterNumbersLoading"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :page.sync="pagination.page"
                                :mobile-breakpoint="0"
                                name="costCenterNumbersData"
                                @pagination="updatePagination"
                            >
                                <template #item.newNumber="{item}">
                                    {{ item.newNumber || 'brak' }}
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj"
                                                    v-on="on"
                                                    @click="showEditCostCenterNumberDialog(item)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </transition>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import CostCenterNumberDialog from './CostCenterNumberDialog'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'
import tooltipDelay from '@/mixins/tooltip'
import { hasUserPermission } from '@/utils/permissionsHandler'

import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CostCenterNumberList',
    components: {
        PageTitle,
        CostCenterNumberDialog
    },
    mixins: [
        pagination,
        filters,
        tooltipDelay,
    ],
    data() {
        return {
            paginationChangeDisabled: false,
            costCenterNumber: {},
            costCenterNumberDialog: false,
            syncLoading: false,
            headers: [
                {
                    text: 'Kod',
                    value: 'newNumber',
                    sortable: false
                },
                {
                    text: 'Opis',
                    value: 'description',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        costCenterNumbers() {
            return this.$store.state.administration.costCenterNumbers.costCenterNumbers
        },
        costCenterNumbersLoading() {
            return this.$store.state.administration.costCenterNumbers.costCenterNumbersLoading
        },
        hasFinancesCreatePermission() {
            return hasUserPermission('finances_create')
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    mounted() {
        this.getCostCenterNumbers()
    },
    methods: {
        getCostCenterNumbers() {
            this.$store.dispatch('administration/getCostCenterNumbers', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCostCenterNumberDialog() {
            this.costCenterNumberDialog = true

        },
        showEditCostCenterNumberDialog(costCenterNumber) {
            this.costCenterNumber = costCenterNumber
            this.costCenterNumberDialog = true

        },
        closeCostCenterNumberDialog() {
            this.costCenterNumberDialog = false

            setTimeout(() => {
                this.costCenterNumber = {}
            }, 500)
        },
        syncCostCenterNumbers() {
            this.syncLoading = true
            this.$store.dispatch('administration/syncCostCenterNumbers')
                .then(() => {
                    this.getCostCenterNumbers()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.syncLoading = false
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (this.paginationChangeDisabled) {
                this.clearPaginationPending()

                return
            }

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCostCenterNumbers()
            }
            this.clearPaginationPending()
        },
        changeFilter() {
            this.paginationChangeDisabled = true
            this.resetPagination()
            this.pagination.page = 1

            this.$nextTick(() => {
                this.getCostCenterNumbers()
                this.paginationChangeDisabled = false
            })
        }
    }
}
</script>
